export const GLOBAL_ADMIN_AUTHORIZE_ROLES = ['customer_success', 'global_customer_manager'] as const

export const GLOBAL_ADMIN_ROUTE_PATHS = {
  reportingLicenses: '/global-admin/reporting-licenses',
  subsidiaries: '/global-admin/subsidiaries',
} as const

export const GLOBAL_ADMIN_ROUTE_META = {
  reportingLicenses: {
    title: 'Reporting & Licenses',
    description: 'Global administration reporting and licenses page.',
  },
  subsidiaries: {
    title: 'Subsidiaries',
    description: 'Global administration subsidiaries page.',
  },
} as const

export const GLOBAL_ADMIN_SUBSIDIARY_DEFAULT_PATH = '/home'

const isIpV4Address = (hostname: string): boolean => /^\d{1,3}(?:\.\d{1,3}){3}$/.test(hostname)

const isIpV6Address = (hostname: string): boolean => hostname.includes(':')

export const buildSubsidiaryUrl = (
  subdomain: string,
  pathname: string = GLOBAL_ADMIN_SUBSIDIARY_DEFAULT_PATH,
): string => {
  if (!subdomain || typeof window === 'undefined') {
    return pathname
  }

  const currentUrl = new URL(window.location.href)
  const hostSegments = currentUrl.hostname.split('.')
  const canReplaceSubdomain =
    hostSegments.length > 2 &&
    currentUrl.hostname !== 'localhost' &&
    !isIpV4Address(currentUrl.hostname) &&
    !isIpV6Address(currentUrl.hostname)

  if (canReplaceSubdomain) {
    hostSegments[0] = subdomain
    currentUrl.hostname = hostSegments.join('.')
  }

  currentUrl.pathname = pathname
  currentUrl.search = ''
  currentUrl.hash = ''

  return currentUrl.toString()
}
